import styled from "styled-components";
import { media } from "../../../../utils/breakpoints";

interface HeadingStyledProps {
  isNameAvailable?: boolean;
}

interface StationSelectionWrapperStyledProps {
  hasSelection: boolean;
  isDisabled: boolean;
}

interface CurrentItemStyledProps {
  hasSelection: boolean;
}

interface HelpDropdownBtnProps {
  active: boolean;
}

export const HeadingStyled = styled.div<HeadingStyledProps>`
  font-size: 48px;
  color: ${(props) => (props.isNameAvailable ? "#0f625f" : "#d1d1d1")};

  ${media.tablet} {
    font-size: 36px;
  }
`;

export const StationSelectionWrapperStyled = styled.div<StationSelectionWrapperStyledProps>`
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0px 16px 0px 0px;
  width: 100%;
  /* 56px tablet → toward original 72px desktop. */
  height: clamp(56px, 5vh, 72px);
  border: 1px solid #d1d1d1;
  border-radius: 0px;
  background: ${(props) => (props.hasSelection ? "#fff" : "#3f7f7d")};
  cursor: ${(props) => (props.isDisabled ? "not-allowed" : "pointer")};

  ${media.tablet} {
    height: 48px;
  }
`;

export const StationSelectorDropdownStyled = styled.div<HelpDropdownBtnProps>`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  height: 100%;
  gap: 8px;
  outline: none;

  &:focus-visible {
    outline: 2px solid #55b8b3;
    outline-offset: 2px;
  }

  svg {
    width: 24px;
    height: 24px;
    flex-shrink: 0;
    transform: ${(props) =>
      props.active ? "rotateX(180deg)" : "rotateX(0deg)"};
    transition: 0.3s;
  }
`;

export const CurrentItemStyled = styled.div<CurrentItemStyledProps>`
  font-family: "Readex Pro", sans-serif;
  font-weight: 400;
  /* 20px tablet → 24px desktop. */
  font-size: clamp(20px, 1.3vw, 24px);
  line-height: 120%;
  color: #08192d;
  display: flex;
  align-items: center;
  padding: 0px 8px;
  gap: 8px;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DropdownContentStyled = styled.div`
  background-color: #ffffff;
  position: absolute;
  width: 100%;
  /* Track the picker's bottom regardless of breakpoint height. */
  top: 100%;
  padding: 8px 0;
  box-shadow: rgba(149, 157, 165, 0.2) 0 8px 24px;
  z-index: 10000;
  max-height: 400px;
  overflow-y: auto;
`;

export const DropdownItemStyled = styled.div`
  font-size: 16px;
  color: #606060;
  padding: 14px 18px;
  border-bottom: 1px solid transparent;
  transition: all 0.3s;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  cursor: pointer;
  outline: none;

  &:hover,
  &[data-focused="true"] {
    color: #55b8b3;
    border-bottom: 1px solid #55b8b3;
    background-color: #f5f5f5;
  }

  &[aria-selected="true"] {
    font-weight: 500;
    color: #3f7f7d;
  }
`;
